var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'kiswe-pill',
    ("kiswe-pill--theme-" + _vm.theme),
    ("kiswe-pill--size-" + _vm.size),
    ("kiswe-pill--outline-" + _vm.useOutline)
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }